import React from "react";
import ContactSection from "@/components/ContactSection";

export default function ContactPage() {
  return (
    <>
      <ContactSection />
    </>
  );
}
